import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
//import GAProvider from 'provider/GAProvider';
import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import App from './App.js';
import CacheBuster from './CacheBuster';
import configureStore from './configureStore';

// import MyMatomoProvider from './provider/MyMatomoProvider';
import { blue } from './themes';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'themes/index.scss';
//import MyMatomoProvider from './provider/MyMatomoProvider';
import GAProvider from 'provider/GAProvider';

import 'moment/locale/vi';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
const locale = 'vi';
const store = configureStore();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const Component = () => {
  return (
    <GAProvider>
      {/* <MyMatomoProvider> */}
      <LocalizationProvider dateAdapter={AdapterMoment} locale={locale}>
        <ConfigProvider
          locale={{
            locale: 'vi_VN',
            Pagination: {
              items_per_page: '/ Trang',
            },
          }}
        >
          <QueryClientProvider client={queryClient}>
            <Provider store={store}>
              <CacheBuster>
                <ThemeProvider theme={blue}>
                  <App />
                </ThemeProvider>
              </CacheBuster>
            </Provider>
          </QueryClientProvider>
        </ConfigProvider>
      </LocalizationProvider>
      {/* </MyMatomoProvider> */}
    </GAProvider>
  );
};

let render = () => {
  ReactDOM.render(<Component />, document.getElementById('root'));
};

ReactDOM.render(
  <BrowserRouter basename='/'>
    <Component />
  </BrowserRouter>,
  document.getElementById('root')
);
